import { gql } from 'graphql-request';

export const NOTE_REMINDER_FRAGMENT = gql`
  fragment NoteReminderFields on NoteReminder {
    createdAt
    customMessage
    deliveryDateUtc
    entityId
    entityType
    id
    reminderEvent {
      id
      type
      description
    }
    reminderTarget {
      id
      targetKey
      targetValue
      operationType
      targetMetadata
      objectIdentifier
    }
    status
    type
    updatedAt
    userId
    userTimezone
  }
`;
